import { ActionModal } from '@insurancemenu/imenu-components-lib';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTriggerRenewalsPageStore } from 'store/pages/tools/trigger-renewals/pageStore';
import PeriodsModalTable from '../WarningModals/PeriodsModalTable';

const RemovePeriodModal: React.FC = observer(() => {
  const {
    renewalGroupActionDelegate: { removePeriodModalDelegate },
  } = useTriggerRenewalsPageStore();
  const { isVisible, isLoading, period, groupName, close, confirm } = removePeriodModalDelegate;

  if (!period) {
    return null;
  }

  return (
    <ActionModal
      show={isVisible}
      loading={isLoading}
      onClose={close}
      onAction={confirm}
      title="Please Confirm an Action"
      subtitle="This action will remove the current period. You will no longer be able to make any changes for this period."
      actionButtonText="Remove period"
      modalType={ModalType.DELETE}
      modalContent={<PeriodsModalTable periods={[period]} groups={[{ id: period.groupId, name: groupName }]} />}
    />
  );
});

export default RemovePeriodModal;
